<template>
  <div class="column is-narrow">
    <div class="container" style="width: 300px;">
      <div class="overviewBanner">
        <div class="headerBanner">
          <h2 class="title is-size-5">Project {{ project.name }}</h2>
        </div>
        <br />
        <div class="textArea" ref="overviewMenu">
          <div class="menuItem" :class="{ 'selected-menu': activeMenu == 'buildings' }">
            <a @click="active('buildings')">
              <h5 class="title is-6">Gebouwen</h5>
            </a>
          </div>
          <div class="menuItem" :class="{ 'selected-menu': activeMenu == 'info' }">
            <a @click="active('info')">
              <h5 class="title is-6">Project Info</h5>
            </a>
          </div>
          <div class="menuItem" :class="{ 'selected-menu': activeMenu == 'users' }">
            <a @click="active('users')">
              <h5 class="title is-6">Gebruikers</h5>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserService from '@/services/userService'
import projectService from '@/services/projectService'

export default {
  components: {},
  filters: {},
  props: {},
  data() {
    return {
      activeMenu: 'buildings'
    }
  },
  computed: {
    ...mapGetters(['project'])
  },
  beforeCreate() {},

  async mounted() {
    console.log('%cMounted and Loading Data', 'color:yellow;')
    const initProjectId = this.$route.params.id
    if (this.$store.getters.project.projectId != initProjectId) {
      const res = await projectService.getProject(initProjectId)
      await this.$store.dispatch('setProject', res.data)
    }
  },
  methods: {
    active(id) {
      this.activeMenu = id
      this.$emit('viewChanged', id)
    }
  }
}
</script>

<style lang="scss">
@import '../../sass/main.scss';

$opacity: 0.2;
.menuItem.selected-menu {
  background-color: lighten($gray, 20%);
}
.overviewBanner {
  position: fixed;
  margin-left: -20px;
  width: 300px;

  .label {
    color: $off-white;
    float: left;
  }
  // position: äbsolute;
  float: right;
  top: 0;
  height: 100%;
  background-color: $gray; //lighten($gray, 5%);

  //border-radius: 7px;
  border: 1px solid #555;
  .title {
    color: $off-white;
  }
  .headerBanner {
    padding: 10px;
    padding-bottom: 17px;

    //background-color: lighten($gray, 5%);
    padding-top: 62px;

    border: 1px solid $off-white;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    .title {
      color: $off-white;
    }
  }
  .textArea {
    padding: 10px;
    padding-top: 0px;
    height: 100%;
    margin-top: -23px;
    .menuItem {
      border: 1px solid $off-white;
      border-top: 0px;
      border-right: 0;
      border-left: 0;
      padding: 8px;
      margin-right: -10px;
      margin-left: -10px;
      margin-bottom: 0px;
      .title {
        padding: 5px;
        padding-left: 10px;
      }
    }

    .label {
      color: $off-white;
    }
    .menuItem:hover {
      background-color: lighten($gray, 20%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/OverviewMenu.vue